



































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import PointerMenu from "../general/PointerMenu.vue";
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";
import HtmlEditor from "../controls/HtmlEditor.vue";
import FormImageBase64 from "../general/FormImageBase64.vue";
import LocationInput from "../general/LocationInput.vue";
import MaterialItemInput from "../general/MaterialItemInput.vue";
import StaffInput from "../general/StaffInput.vue";
import FormPrice from "../general/FormPrice.vue";

import SettingsJson from "../../shared/SettingsJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import PriceJson, { defaultPriceJson } from "../../shared/PriceJson";
import EventTemplateJson, { defaultEventTemplateJson } from "../../shared/EventTemplateJson";
import EventJson, { EventDescriptionAllowedTags, defaultEventJson } from "../../shared/EventJson";
import { EventTemplateStatus, EventTemplateStatusNames } from "../../shared/EventTemplateStatus";
import EventImageJson, { defaultEventImageJson } from "../../shared/EventImageJson";

import Utils from "../../shared/Utils";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import {
  validateEventTemplateJsonManagementAdd,
  validateEventTemplateJsonManagement,
} from "../../shared/EventTemplateJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import PriceTemplates from "../custom/PriceTemplates";

type keysForCachedPrices = {
  [key in keyof Pick<
    PriceJson,
    | "priceDeposit"
    | "priceDepositAdditionalParticipant"
    | "priceNonDeposit"
    | "priceNonDepositAdditionalParticipant"
    | "cancellationFee"
  >]: string;
};

export default Vue.extend({
  name: "EventsTemplateDetails",
  components: {
    OverlayWindow,
    Loading,
    PointerMenu,
    CategoryTypeSelect,
    HtmlEditor,
    FormImageBase64,
    LocationInput,
    MaterialItemInput,
    StaffInput,
    FormPrice,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    eventTemplateId: Number,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Utils: Utils,
      EventTemplateStatus: EventTemplateStatus,
      EventTemplateStatusNames: EventTemplateStatusNames,
      CategoryTypeType: CategoryTypeType,
      EventDescriptionAllowedTags: EventDescriptionAllowedTags,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      categoryTypes: null as CategoryTypeJson[] | null,
      selectedTemplatePrices: {} as { [index: number]: any },
      cachedPrices: [] as keysForCachedPrices[],
      selectedDeletedPriceRestrictToTypes: [] as CategoryTypeJson[][],
      selectedEventTemplateId: null as number | null,
      templateDetails: null as EventTemplateJson | null,
      hasChanges: false,
      hintChanged: {
        staff: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<EventTemplateJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initEventTemplateDetails();
  },
  mounted() {
    this.setCachedData();
  },
  methods: {
    initEventTemplateDetails() {
      this.selectedEventTemplateId = this.eventTemplateId;

      this.loadCategoryTypes();
      this.loadEventTemplateDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {},

    async loadCategoryTypes() {
      this.categoryTypes = null;

      try {
        this.categoryTypes = await this.restClient.getCategoryTypes();

        this.filterDeletedPriceRestrictToTypes();

        this.$nextTick(() => {
          this.hasChanges = false;
        });
      } catch (e) {
        alert(e.message);
      }
    },

    async loadEventTemplateDetails() {
      if (this.selectedEventTemplateId != null) {
        this.templateDetails = await this.restClient.getEventTemplate(this.selectedEventTemplateId);
      } else {
        this.templateDetails = { ...defaultEventTemplateJson() };

        this.markPriceAsNew();
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultPrice(): PriceJson {
      return { ...defaultPriceJson() };
    },

    //START set cached data

    //END set cached data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Vorlage hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Vorlage bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Vorlage";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.templateDetails != null) {
        this.validation = validateEventTemplateJsonManagement(this.templateDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //prices

    addEventPrice() {
      if (this.templateDetails != null) {
        this.templateDetails.eventPrices.push(this.getDefaultPrice());

        this.markPriceAsNew();
      }
    },

    deleteEventPrice(index: number) {
      if (this.templateDetails != null && this.templateDetails.eventPrices != null) {
        this.templateDetails.eventPrices.splice(index, 1);
        this.cachedPrices.splice(index, 1);

        delete this.toValidate["eventPrices-" + index];
      }
    },

    markPriceAsNew() {
      if (this.templateDetails != null) {
        let index = this.templateDetails.eventPrices.length - 1;
        this.selectedTemplatePrices[index] = null;
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    addEventImage() {
      if (this.templateDetails != null) {
        if (this.templateDetails.eventImages.length < 5) {
          this.templateDetails.eventImages.push({ ...defaultEventImageJson() });
        }
      }
    },

    deleteEventImage(index: number) {
      if (this.templateDetails != null) {
        this.templateDetails.eventImages.splice(index, 1);

        delete this.toValidate["eventImages-" + index];
      }
    },

    async addNewTemplate() {
      if (this.templateDetails != null) {
        this.loadingGeneral = true;

        this.validation = validateEventTemplateJsonManagementAdd(this.templateDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.templateDetails = await this.restClient.addEventTemplate(this.templateDetails);
            alert("Die Vorlage wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Die Vorlage konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveTemplate() {
      if (this.templateDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateEventTemplateJsonManagement(this.templateDetails);
          //todo ###END
          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedTemplateDetails = await this.restClient.updateEventTemplate(this.templateDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteTemplate() {
      if (this.selectedEventTemplateId != null) {
        let c = confirm("Wollen Sie diese Vorlage wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteEventTemplate(this.selectedEventTemplateId);
              this.closeDetails();
              alert("Die Vorlage wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    filterDeletedPriceRestrictToTypes() {
      if (this.templateDetails != null) {
        var prices = this.templateDetails.eventPrices;

        for (let i = 0; i < prices.length; i++) {
          var filteredDeletedRestrictToTypes: CategoryTypeJson[] = [];

          if (this.categoryTypes != null && prices[i].restrictToTypes != null) {
            filteredDeletedRestrictToTypes = prices[i].restrictToTypes!.filter(
              (pt: CategoryTypeJson) => !this.categoryTypes!.map((ct: CategoryTypeJson) => ct.ID).includes(pt.ID)
            );
          }

          this.selectedDeletedPriceRestrictToTypes[i] = [...filteredDeletedRestrictToTypes];
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    templateDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    parseEventRegistrationMaximumCount: {
      get(): number | undefined {
        if (this.templateDetails != null) {
          return this.templateDetails.eventRegistrationMaximumCount;
        }
      },
      set(value: string) {
        if (this.templateDetails != null) {
          this.templateDetails.eventRegistrationMaximumCount = parseInt(value);
        }
      },
    },

    parseEventWaitingListMaximumCount: {
      get(): number | undefined {
        if (this.templateDetails != null) {
          return this.templateDetails.eventWaitingListMaximumCount;
        }
      },
      set(value: string) {
        if (this.templateDetails != null) {
          this.templateDetails.eventWaitingListMaximumCount = parseInt(value);
        }
      },
    },

    parseEventRestrictMinimumAge: {
      get(): number | null | undefined {
        if (this.templateDetails != null) {
          return this.templateDetails.eventRestrictMinimumAge;
        }
      },
      set(value: string) {
        if (this.templateDetails != null) {
          if (value == "") {
            this.templateDetails.eventRestrictMinimumAge = null;
          } else {
            this.templateDetails.eventRestrictMinimumAge = parseInt(value);
          }
        }
      },
    },

    parseRestrictMaximumAge: {
      get(): number | null | undefined {
        if (this.templateDetails != null) {
          return this.templateDetails.eventRestrictMaximumAge;
        }
      },
      set(value: string) {
        if (this.templateDetails != null) {
          if (value == "") {
            this.templateDetails.eventRestrictMaximumAge = null;
          } else {
            this.templateDetails.eventRestrictMaximumAge = parseInt(value);
          }
        }
      },
    },

    selectedDeletedCategoryTypes(): CategoryTypeJson[] {
      let filteredRestrictToTypes: CategoryTypeJson[] = [];

      if (this.templateDetails?.eventRestrictToTypes != null) {
        filteredRestrictToTypes = this.templateDetails.eventRestrictToTypes;
        filteredRestrictToTypes = filteredRestrictToTypes.filter((i: CategoryTypeJson) => {
          if (this.categoryTypes != null) {
            if (!this.categoryTypes.includes(i)) {
              return i;
            }
          }
        });
      }

      return filteredRestrictToTypes;
    },
  },
});
